<template>
    <footer class="footer">
        <div class="container">
            <hr>
            <div class="row align-items-center justify-content-between">
                <ul class="nav nav-footer">
                    <li class="nav-item">
                        <a href="http://azf.vc/koko" class="nav-link" target="_blank" rel="noopener">{{ $t("access") }}</a>
                    </li>
                    <li class="nav-item">
                        <a href="mailto:pitch@shizen.vc" class="nav-link" target="_blank" rel="noopener">{{ $t("contact") }}</a>
                    </li>
                    <li v-if="this.$i18n.locale === 'jp'" class="nav-item">
                        <router-link to="/about" class="nav-link">自然キャピタルについて</router-link>
                    </li>
                </ul>
                <div class="copyright">
                    {{ $t("companyname") }} &copy; {{year}}
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'footerView',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
    .footer{
        background-image: url("/img/background.png");
        background-size: cover;
        color: #fff;
    }
</style>
